// extracted by mini-css-extract-plugin
export default {"wrapper":"h1pmRx","description":"x1DgxX"};